/* Ticketraster der Kuji-Karte.

   Der Bestand steht als Reihe einzelner Striche. Gerendert werden sie
   serverseitig in snippets/card-product-kuji.liquid, damit die Karte nicht
   erst nach dem Skript ihre endgültige Höhe findet. Diese Datei zieht sie
   danach auf den Live-Stand aus der Lottery-App nach.

   Aufgerufen wird sie vom Inline-Skript in layout/theme.liquid, das den
   Abruf ohnehin für jede laufende Karte macht:

       window.kujiTicks(card, rem, tot)

   Der Aufruf dort ist abgesichert. Fehlt diese Datei, bleibt es beim
   serverseitigen Stand — die Karte zeigt dann Shopifys Bestand statt des
   Live-Werts, aber sie bricht nicht.

   Ein Strich trägt zwei Tickets. Bei einem Strich je Ticket blieben auf der
   323 px breiten Reihe 2,5 px je Strich, und die Reihe läse sich als Kamm
   statt als abzählbare Dinge. Der Preis dafür: jeder zweite Zug löscht
   keinen Strich. Den trägt der Kopfstrich, der dann erst absinkt und beim
   zweiten Ticket ganz erlischt. */
(function () {
  if (window.kujiTicks) return;

  /* Höhe eines erloschenen Strichs, in Prozent von scaleY(1). Muss mit
     .kuji-tick--out in card-product-kuji.css übereinstimmen, sonst springt
     der Kopfstrich beim Erlöschen. */
  var OUT = 42;

  /* Versatz zwischen zwei erlöschenden Strichen. Bei mehr als einer Handvoll
     auf einmal liest man ohnehin keine Reihenfolge mehr — der Versatz sagt
     nur "das waren mehrere", nicht "das waren genau sieben". */
  var STAGGER = 40;

  function state(row, rem) {
    var per = parseInt(row.getAttribute('data-kuji-per'), 10) || 2;
    if (per < 1) per = 1;
    var lit = rem > 0 ? Math.ceil(rem / per) : 0;
    return {
      per: per,
      lit: lit,
      /* Wie viele Tickets der Kopfstrich noch trägt: bei vollem Strich
         gleich per, sonst weniger. */
      rest: lit > 0 ? rem - (lit - 1) * per : per
    };
  }

  function stockClass(rem, tot) {
    if (!tot || tot < 1) return 'kuji-stock-mid';
    var pct = Math.floor(rem * 100 / tot);
    return pct >= 71 ? 'kuji-stock-mid' : pct >= 31 ? 'kuji-stock-low' : 'kuji-stock-end';
  }

  window.kujiTicks = function (card, rem, tot) {
    var row = card.querySelector('.kuji-ticks');
    if (!row) return;

    var ticks = row.querySelectorAll('.kuji-tick');
    if (!ticks.length) return;

    var next = state(row, Math.max(rem, 0));
    /* Der Stand vor dem Abruf steht im DOM, nicht in einer Variablen: die
       Karte kann aus dem Cache kommen oder vom Server, und in beiden Fällen
       ist das Markup die Wahrheit. */
    var prevLit = row.querySelectorAll('.kuji-tick:not(.kuji-tick--out)').length;
    var sold = prevLit > next.lit;

    row.className = row.className.replace(/\s*kuji-stock-\w+/g, '');
    row.classList.add(stockClass(rem, tot));

    for (var i = 0; i < ticks.length; i++) {
      var tick = ticks[i];
      var on = i < next.lit;

      tick.classList.remove('kuji-tick--tip', 'kuji-tick--part');
      tick.style.removeProperty('--kuji-tick-scale');

      if (!on && sold && i < prevLit) {
        /* Neustart der Animation erzwingen — ohne das Auslesen von
           offsetWidth läuft sie bei einem zweiten Abruf nicht noch einmal. */
        tick.classList.remove('kuji-tick--selling');
        void tick.offsetWidth;
        tick.style.animationDelay = ((prevLit - 1 - i) * STAGGER) + 'ms';
        tick.classList.add('kuji-tick--selling');
      } else {
        tick.classList.remove('kuji-tick--selling');
        tick.style.animationDelay = '';
      }

      if (on) {
        tick.classList.remove('kuji-tick--out');
      } else {
        tick.classList.add('kuji-tick--out');
      }

      if (on && i === next.lit - 1) {
        tick.classList.add('kuji-tick--tip');
        if (next.rest < next.per) {
          tick.classList.add('kuji-tick--part');
          tick.style.setProperty(
            '--kuji-tick-scale',
            OUT + Math.round(next.rest * (100 - OUT) / next.per)
          );
        }
      }
    }
  };
})();
